module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_troendelag_pos.e751ca9f.png";